/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';

/**
 * 
 * @export
 * @interface DatabaseSequenceField
 */
export interface DatabaseSequenceField extends DatabaseField {
    /**
     * Optional prefix for display (e.g. "#" or "TK-")
     * @type {string}
     * @memberof DatabaseSequenceField
     */
    prefix?: string;
    /**
     * Zero-pad the number to this length (e.g. 4 →
     * @type {number}
     * @memberof DatabaseSequenceField
     */
    padLength?: number;
    /**
     * Starting value for the sequence (default 1)
     * @type {number}
     * @memberof DatabaseSequenceField
     */
    startValue?: number;
}

/**
 * Check if a given object implements the DatabaseSequenceField interface.
 */
export function instanceOfDatabaseSequenceField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseSequenceFieldFromJSON(json: any): DatabaseSequenceField {
    return DatabaseSequenceFieldFromJSONTyped(json, false);
}

export function DatabaseSequenceFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseSequenceField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'prefix': !exists(json, 'prefix') ? undefined : json['prefix'],
        'padLength': !exists(json, 'padLength') ? undefined : json['padLength'],
        'startValue': !exists(json, 'startValue') ? undefined : json['startValue'],
    };
}

export function DatabaseSequenceFieldToJSON(value?: DatabaseSequenceField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'prefix': value.prefix,
        'padLength': value.padLength,
        'startValue': value.startValue,
    };
}

